import React from "react";
import { ErrorMessage, Field } from "formik";
import FormListButton from "../FormListButton";
import styles from "./FormListSingleFieldItem.module.scss";

const FormListSingleFieldItem = ({
    type,
    name,
    placeholder,
    buttonText,
    buttonOnClick,
    ...props
}) => {
    return (
        <>
            <div className={styles.FormListSingleFieldItemContainer}>
                <Field
                    type={type}
                    className="form-control"
                    name={name}
                    placeholder={placeholder}
                />
                <FormListButton text={buttonText} onClick={buttonOnClick} />
            </div>
            <ErrorMessage
                className="error-message"
                component="div"
                name={name}
            />
        </>
    );
};

export default FormListSingleFieldItem;
